export class GalleryImageStyle {
  transition = 'uk-transition-fade';
  boxDecoration = '';
  boxShadow = '';
  hoverBoxShadow = '';
  inverseStyle = '';
  width: number | null = null;
  height: number | null = null;

  static normalize(styles: Partial<GalleryImageStyle>): GalleryImageStyle {
    const pureStyles = new GalleryImageStyle();

    pureStyles.transition = styles.transition ?? pureStyles.transition;
    pureStyles.boxDecoration = styles.boxDecoration ?? pureStyles.boxDecoration;
    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;
    pureStyles.hoverBoxShadow = styles.hoverBoxShadow ?? pureStyles.hoverBoxShadow;
    pureStyles.inverseStyle = styles.inverseStyle ?? pureStyles.inverseStyle;
    pureStyles.width = styles.width ?? pureStyles.width;
    pureStyles.height = styles.height ?? pureStyles.height;

    return pureStyles;
  }
}
